module.exports = __webpack_public_path__ + "images/default-c2b6114.png";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/slider-v1/images/default.png
// module id = 107
// module chunks = 2